export default __webpack_public_path__ + "static/media/suomisport-logo.e2c604a6.svg";